import { render } from "./newsAdd.vue?vue&type=template&id=21de67c2&scoped=true"
import script from "./newsAdd.vue?vue&type=script&lang=js"
export * from "./newsAdd.vue?vue&type=script&lang=js"

import "./newsAdd.vue?vue&type=style&index=0&id=21de67c2&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21de67c2"]])

export default __exports__